import React, { ReactNode, useEffect, useState } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
// import { Button } from 'primereact/button';
import { Link } from '@tanstack/react-router';
export type MenuItemHeader = {
  title: string;
  links: Array<MenuItem>;
};
export type MenuItem = {
  title: string;
  url: string;
};
export type AccordionMenuData = Array<MenuItemHeader>;

export type AccordionMenuProps = {
  items: MenuItemHeader[] | null;
  activeIndex?: number;
};
export const AccordionMenu = ({ items, activeIndex }: AccordionMenuProps) => {
  const [localActiveIndex, setLocalActiveIndex] = useState<number | number[]>();
  const [aItems, setAItems] = useState<ReactNode[]>([]);

  // const headers = items.links.map((header, index) => {
  //    return <Button
  //        outlined={activeIndex !== 0}
  //        rounded
  //        label="1"
  //        onClick={() => setActiveIndex(index)}
  //        className="w-2rem h-2rem p-0" />
  // });
  useEffect(() => {
    console.log('on activeIndex', activeIndex);
    if (activeIndex !== undefined) {
      setLocalActiveIndex([activeIndex]);
    }
  }, [activeIndex]);

  useEffect(() => {
    if (items) {
      const subItems = items.map((header) => {
        return (
          <AccordionTab key={header.title} header={header.title}>
            {header.links.map((item) => {
              // return <p><{item.title}</p>
              return (
                <div key={item.url}>
                  <Link
                    style={{}}
                    to={item.url}
                    activeProps={{
                      className: 'font-bold active',
                    }}
                  >
                    {item.title}
                  </Link>
                </div>
              );
            })}
          </AccordionTab>
        );
      });
      setAItems(subItems);
    }
  }, [items]);

  return (
    <div className="card">
      {/*<div className="flex flex-wrap justify-content-end gap-2 mb-3">*/}
      {/*    {headers}*/}
      {/*</div>*/}
      <Accordion
        multiple
        activeIndex={localActiveIndex}
        onTabChange={(e) => {
          console.log('on tab change', e.index);
          setLocalActiveIndex(e.index);
        }}
        // onClick={(e) => console.log(e)}
      >
        {aItems}
      </Accordion>
    </div>
  );
};
